var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCalendarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.99996C2.5 7.66641 2.5 6.49963 2.95414 5.60833C3.35361 4.82432 3.99103 4.1869 4.77504 3.78743C5.66634 3.33329 6.83311 3.33329 9.16667 3.33329H10.8333C13.1669 3.33329 14.3337 3.33329 15.225 3.78743C16.009 4.1869 16.6464 4.82432 17.0459 5.60833C17.5 6.49963 17.5 7.66641 17.5 9.99996V11.6666C17.5 14.0002 17.5 15.167 17.0459 16.0583C16.6464 16.8423 16.009 17.4797 15.225 17.8792C14.3337 18.3333 13.1669 18.3333 10.8333 18.3333H9.16667C6.83311 18.3333 5.66634 18.3333 4.77504 17.8792C3.99103 17.4797 3.35361 16.8423 2.95414 16.0583C2.5 15.167 2.5 14.0002 2.5 11.6666V9.99996Z",
    fill: "current",
    mask: "url(#topBar)",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.91663V1.66663M13.3333 2.91663V1.66663M9.16667 18.3333H10.8333C13.1669 18.3333 14.3337 18.3333 15.225 17.8792C16.009 17.4797 16.6464 16.8423 17.0459 16.0583C17.5 15.167 17.5 14.0002 17.5 11.6666V9.99996C17.5 7.66641 17.5 6.49963 17.0459 5.60833C16.6464 4.82432 16.009 4.1869 15.225 3.78743C14.3337 3.33329 13.1669 3.33329 10.8333 3.33329H9.16667C6.83311 3.33329 5.66634 3.33329 4.77504 3.78743C3.99103 4.1869 3.35361 4.82432 2.95414 5.60833C2.5 6.49963 2.5 7.66641 2.5 9.99996V11.6666C2.5 14.0002 2.5 15.167 2.95414 16.0583C3.35361 16.8423 3.99103 17.4797 4.77504 17.8792C5.66634 18.3333 6.83311 18.3333 9.16667 18.3333Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 7.91663H13.3333",
    fill: "none",
    stroke: "#f2f2f2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "#f2f2f2 !important"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilled);
export default __webpack_public_path__ + "static/media/calendar-filled.dc3d45be94e0e79c73ae29b8c50871d6.svg";
export { ForwardRef as ReactComponent };